export default (fn, t) => {
  fn()
  return setInterval(fn, t)
}
